import { render, staticRenderFns } from "./AdminPostForm.vue?vue&type=template&id=18ae9efa&scoped=true"
import script from "./AdminPostForm.vue?vue&type=script&lang=js"
export * from "./AdminPostForm.vue?vue&type=script&lang=js"
import style0 from "./AdminPostForm.vue?vue&type=style&index=0&id=18ae9efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae9efa",
  null
  
)

export default component.exports